// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpecialChanceBoard_information__cDULG {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 16px;
  min-height: 112px;
}

.SpecialChanceBoard_information-inner__CCmvW {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: #507687;
  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),
    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);
  width: 100%;
  margin-bottom: 16px;
  position: relative;
}

.SpecialChanceBoard_information-title__kB724 {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  padding: 8px 0px;
  align-items: center;
  background: rgba(255, 255, 255, 0.16);
}

.SpecialChanceBoard_information-title__kB724 div {
  width: 50%;
  display: flex;
  justify-content: center;
}

.SpecialChanceBoard_information-title__kB724 span {
  color: #fcfaee;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.SpecialChanceBoard_information-items__KN29K {
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  margin-top: 4px;
}

.SpecialChanceBoard_information-item__FXn2- {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
}

.SpecialChanceBoard_information-item-number__cF5sw {
  color: #fcfaee;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 325;
  line-height: 36px;
  margin-left: 4px;
}

.SpecialChanceBoard_information-item-arrow__HGE52 {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 18px;
}

.SpecialChanceBoard_information-item-leter__ZBVlU {
  color: #fcfaee;
  font-size: 12px;
  font-style: normal;
  font-weight: 325;
  line-height: 36px;
}

.SpecialChanceBoard_information-line__WPnfe {
  width: 1px;
  background: rgba(252, 252, 237, 0.2);
  height: 24px;
}

.SpecialChanceBoard_informationAll__g7X84 {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fcfaee;
  text-align: center;
  font-feature-settings: "ss01" on;
  gap: 4px;
  font-size: 16px;
  font-style: normal;
  font-weight: 450;
  line-height: 36px;
  height: 45px;
}

.SpecialChanceBoard_description__g\\+0Hl {
  padding: 8px 16px;
  margin-top: 4px;
  border-top: 2px solid rgba(255, 255, 255, 0.2);
}

.SpecialChanceBoard_description__g\\+0Hl p {
  color: #fcfaee;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

@media screen and (min-width: 1200px) {
  .SpecialChanceBoard_share__ice6X {
    padding-top: unset;
  }
  .SpecialChanceBoard_title__5f2Tw {
    font-size: 16px;
  }
  .SpecialChanceBoard_rule__Ibh5o {
    font-size: 13px;
  }
  .SpecialChanceBoard_information-title__kB724 span {
    font-size: 14px;
  }
  .SpecialChanceBoard_informationAll__g7X84 {
    font-size: 14px;
  }
  .SpecialChanceBoard_informationAll__g7X84 div span:nth-child(1) {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SpecialChanceBoard/SpecialChanceBoard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB;;;;0CAIwC;EACxC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".information {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 16px;\n  min-height: 112px;\n}\n\n.information-inner {\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: #507687;\n  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),\n    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);\n  width: 100%;\n  margin-bottom: 16px;\n  position: relative;\n}\n\n.information-title {\n  width: 100%;\n  display: flex;\n  justify-content: space-evenly;\n  padding: 8px 0px;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.16);\n}\n\n.information-title div {\n  width: 50%;\n  display: flex;\n  justify-content: center;\n}\n\n.information-title span {\n  color: #fcfaee;\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.information-items {\n  display: flex;\n  width: 100%;\n  justify-content: space-around;\n  align-items: center;\n  margin-top: 4px;\n}\n\n.information-item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50%;\n}\n\n.information-item-number {\n  color: #fcfaee;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 325;\n  line-height: 36px;\n  margin-left: 4px;\n}\n\n.information-item-arrow {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  left: 18px;\n}\n\n.information-item-leter {\n  color: #fcfaee;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 325;\n  line-height: 36px;\n}\n\n.information-line {\n  width: 1px;\n  background: rgba(252, 252, 237, 0.2);\n  height: 24px;\n}\n\n.informationAll {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fcfaee;\n  text-align: center;\n  font-feature-settings: \"ss01\" on;\n  gap: 4px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 36px;\n  height: 45px;\n}\n\n.description {\n  padding: 8px 16px;\n  margin-top: 4px;\n  border-top: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.description p {\n  color: #fcfaee;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n@media screen and (min-width: 1200px) {\n  .share {\n    padding-top: unset;\n  }\n  .title {\n    font-size: 16px;\n  }\n  .rule {\n    font-size: 13px;\n  }\n  .information-title span {\n    font-size: 14px;\n  }\n  .informationAll {\n    font-size: 14px;\n  }\n  .informationAll div span:nth-child(1) {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"information": `SpecialChanceBoard_information__cDULG`,
	"information-inner": `SpecialChanceBoard_information-inner__CCmvW`,
	"information-title": `SpecialChanceBoard_information-title__kB724`,
	"information-items": `SpecialChanceBoard_information-items__KN29K`,
	"information-item": `SpecialChanceBoard_information-item__FXn2-`,
	"information-item-number": `SpecialChanceBoard_information-item-number__cF5sw`,
	"information-item-arrow": `SpecialChanceBoard_information-item-arrow__HGE52`,
	"information-item-leter": `SpecialChanceBoard_information-item-leter__ZBVlU`,
	"information-line": `SpecialChanceBoard_information-line__WPnfe`,
	"informationAll": `SpecialChanceBoard_informationAll__g7X84`,
	"description": `SpecialChanceBoard_description__g+0Hl`,
	"share": `SpecialChanceBoard_share__ice6X`,
	"title": `SpecialChanceBoard_title__5f2Tw`,
	"rule": `SpecialChanceBoard_rule__Ibh5o`
};
export default ___CSS_LOADER_EXPORT___;
